import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzTransferModule } from 'ng-zorro-antd/transfer';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzCalendarModule } from 'ng-zorro-antd/calendar';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzTypographyModule } from 'ng-zorro-antd/typography';

export const ZORRO_MODULES = [
  NzCalendarModule,
  NzDescriptionsModule,
  NzBreadCrumbModule,
  NzSwitchModule,
  NzPageHeaderModule,
  NzPopoverModule,
  NzListModule,
  NzTransferModule,
  NzStepsModule,
  NzTimelineModule,
  NzMessageModule,
  NzAutocompleteModule,
  NzModalModule,
  NzTabsModule,
  NzDrawerModule,
  NzAlertModule,
  NzSkeletonModule,
  NzBadgeModule,
  NzAvatarModule,
  NzCardModule,
  NzProgressModule,
  NzIconModule,
  NzButtonModule,
  NzCheckboxModule,
  NzDatePickerModule,
  NzFormModule,
  NzInputModule,
  NzInputNumberModule,
  NzGridModule,
  NzPaginationModule,
  NzPopconfirmModule,
  NzRadioModule,
  NzCollapseModule,
  NzSelectModule,
  NzSpinModule,
  NzTableModule,
  NzTagModule,
  NzTimePickerModule,
  NzDropDownModule,
  NzMenuModule,
  NzLayoutModule,
  NzToolTipModule,
  NzDividerModule,
  NzUploadModule,
  NzEmptyModule,
  NzStatisticModule,
  NzResultModule,
  NzCarouselModule,
  NzTreeModule,
  NzSpaceModule,
  NzTypographyModule
];
